import * as React from 'react'
import { SignupHeader } from '../headers/SignupHeader'

interface ExpiredLinkPanelProps {
  title: string
  text: string
  icon?: string
}

const ExpiredLinkPanel = ({ title, text, icon = 'bi-hourglass-bottom' }: ExpiredLinkPanelProps) => (
  <>
    <SignupHeader hideAccountCreation />
    <div className='h-50 d-flex align-items-center'>
      <div className='auth-popup-container panel-width-480'>
        <div className='auth-popup-inner auth-popup-invitation-code-expired'>
          <div className='auth-popup-invitation-code-expired-logo'>
            <i className={`bi ${icon} fs-4`} aria-hidden='true' />
          </div>
          <div className='auth-popup-content'>
            <span className='auth-popup-title'>{title}</span>
            <span className='auth-popup-text'>{text}</span>
          </div>
        </div>
      </div>
    </div>
  </>
)

export default ExpiredLinkPanel
